<template>
    <h5 class="mb-3">Alta de Usuario</h5>
    <Form role="form"
          class="text-start"
          :validation-schema="schema"
          @submit="handleAltaUsuario"
          >

        <soft-field
            id="username"
            v-model="user.username"
            type="text"
            label="Usuario"
            placeholder="Indique su usuario"
            name="username"
            class="mb-3"
            largo="30"
        />

        <soft-field
            id="nombre"
            v-model="user.name"
            type="text"
            label="Nombre"
            placeholder="Indique su nombre"
            name="nombre"
            class="mb-3"
            largo="80"
        />

        <soft-field
            id="email"
            v-model="user.email"
            type="email"
            label="Email"
            placeholder="Indique su email de acceso"
            name="email"
            class="mb-3"
        />

        <soft-select
            id="rolid"
            v-model="user.rolid"
            name="rolid"
            :valores="roles"
            label="Rol"
            placeholder="Seleccione rol"
            class="mb-2"
        />

        <soft-select
            id="departamentoid"
            v-model="user.departamentoid"
            name="departamentoid"
            :valores="departamentos"
            label="Departamento"
            placeholder="Seleccione departamento"
            class="mb-3"
        />

        <soft-select
            id="oficinaid"
            v-model="user.oficinaid"
            name="oficinaid"
            :valores="oficinas"
            label="Oficina"
            placeholder="Seleccione oficina"
            class="mb-3"
        />

        <div class="text-center mt-5">
            <soft-button
                class="my-2 mb-2 text-sm text-analiza-light"
                color="analiza-azul"
                full-width
                :is-disabled="loading ? true : false"
                >
                <span
                    v-if="loading"
                    class="spinner-border spinner-border-sm"
                ></span>
                <span v-else>Confirmar</span>
            </soft-button>
        </div>
    </Form>
  </template>
  
  <script>
  import SoftField from "@/components/SoftField.vue";
  import SoftSelect from "@/components/SoftSelect.vue";
  import SoftButton from "@/components/SoftButton.vue";
  import showSwal from "/src/mixins/showSwal.js";
  import {globalFunctionsMixin} from '@/mixins/globalFunctions.js';
  import { Form } from "vee-validate";
  import * as yup from "yup";

  export default {
    name: "AltaUsuarioForm",
    components: {
        SoftField,
        SoftSelect,
        SoftButton,
        Form,
    },
    mixins: [globalFunctionsMixin],
    data() {
        const schema = yup.object().shape({
            email: yup.string().required("El email es necesario!").email("Debe indicar un email válido"),
            username: yup.string().required("El usuario es necesario!").max(30,'El tamaño máximo es de 30 caracteres').matches(/^[a-zA-Z0-9ñÑáéíóúÁÉÍÓÚ.-]+$/, 'El usuario contiene caracteres no permitidos'),
            nombre: yup.string().required("El nombre es necesario!").max(80,'El tamaño máximo es de 80 caracteres'),
            rol_id: yup.number().positive('Debe indicar un rol'),
            departamento_id: yup.number().positive('Debe indicar un departamento'),
            oficina_id: yup.number().positive('Debe indicar una oficina')
        });
        
        return {
            loading: false,
            user:{},
            schema: schema,
            roles: []
        };
    },
    emits: ['cerrar-modal'],
    methods: {
      async handleAltaUsuario() {
        // Aquí puedes realizar acciones cuando se envía el formulario
        console.log('Formulario enviado:', this.user);
        this.loading = true;
        try {
            const resp = await this.$store.dispatch("auth/guardaUsuario", this.user);
            this.loading = false;
            if (resp.res=='OK') {
                showSwal.methods.showSwal({
                    type: "success",
                    message: "Se ha registrado el nuevo usuario",
                    width: 600,
                });
                this.$emit('cerrar-modal');
            }
            else {
                showSwal.methods.showSwal({
                    type: "error",
                    message: resp.mensaje,
                    width: 500
                });               
            }
        } catch (error) {
            this.loading = false;
            showSwal.methods.showSwal({
                type: "error",
                message: "Se ha producido un error",
                width: 500,
            });
        }
      },
    },
    async mounted() {
        this.roles = await this.getRoles();
        this.oficinas = await this.getOficinas();
        this.departamentos = await this.getDepartamentos();
    }
  };
  </script>
  
  <style scoped>
  /* Estilos específicos del componente MyForm */
  </style>